import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { PROJECT_API } from "../../services/apiCalls/projectApiCalls";
import { COMMON_API } from "../../services/apiCalls/commonApi";
import { useLocation } from "react-router-dom";
export default function DocumentRepositoryForm({ rowData }) {
  const location = useLocation();
    const pro = location.state || {};
 
     
  const [selectedFile, setSelectedFile] = useState(null);
  const [projectId, setProjctID] = useState(rowData?.ProjectID || pro.project_id);
  const [projectName, setProjectName] = useState(rowData?.ProjectName || pro.Project_Name);
  const [documentName, setDocumentName] = useState(rowData?.DocumentName || "");
  const [fileUrl, setFileUrl] = useState(rowData?.UploadDocument || "");
  const [customerName, setCustomerName] = useState(rowData?.CustomerName || "");

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
    } else {
      console.warn("No file selected.");
    }
  };
  const resetFields = () => {
    
    setDocumentName("");
    setFileUrl("");
    setSelectedFile(null);
  };
  const handleDocumentSubmit = async () => {
    const user = localStorage.getItem("state");
    const state = JSON.parse(user);

    const validateFields = () => {
      if ((!projectId) || documentName === "" ||selectedFile=== "") {
        toast.error("Please fill in all fields!");
        return false;
      }
      return true;
    };

  

    const saveDocumentFile = async () => {
      if (selectedFile) {
        const allowedType = "application/pdf";
        if (selectedFile.type !== allowedType) {
          toast.error("Only PDF files are allowed!");
          return null;
        }

        const responseFile = await PROJECT_API.saveDocument(selectedFile);
        if (responseFile.fileUrl) {
          setFileUrl(responseFile.fileUrl);
          return responseFile.fileUrl;
        }
      }
      return fileUrl;
    };

    if (!validateFields()) return;
    try {
      const fileUrlToUse = selectedFile ? await saveDocumentFile() : fileUrl;
      if (fileUrlToUse === null) {
        return;
      }

      const payload = {
        ProjectID: projectId,
        ProjectName: projectName,
        DocumentName: documentName,
        UploadDocument: fileUrlToUse,
        UserID: state.user.user_id,
        CustomerName: customerName,
        ID: rowData?.ID
      };

      const apiMethod = COMMON_API.createDocumentRepository;

      const response = await apiMethod(payload);

      if (response && (response.status === 200 || response.status === 201)) {
        toast.success(response.Message);
        resetFields();
      } else {
        toast.error(response?.error || "An error occurred.");
      }
    } catch (error) {
      console.error("Error submitting document:", error);
      toast.error("An unexpected error occurred. Please try again.");
    }
  };

  const handleCancel = () => {
    
   
  };

  return (
    <>
      <div className="mt-2">
        <div className="d-flex">
          <div className="d-flex flex-column" style={{ marginLeft: "30px" }}>
            <label className="input-label" htmlFor="projectName">
              Project Name
            </label>
            <input
              disabled
              className="input-style"
              type="text"
              name="projectName"
              id="projectName"
              value={projectName}
            />
          </div>
          <div className="d-flex flex-column" style={{ marginLeft: "30px" }}>
            <label className="input-label" htmlFor="document_name">
              Document Name
            </label>
            <input
              className="input-style"
              type="text"
              name="document_name"
              id="document_name"
              onChange={(e) => setDocumentName(e.target.value)}
              value={documentName}
              placeholder="Enter Document Name"
              autoComplete="off"
            />
          </div>
          <div className="d-flex flex-column" style={{ marginLeft: "30px" }}>
            <label className="input-label" htmlFor="upload_document">
              Upload Document
            </label>
            <input
              className="input-style"
              type="file"
              name="upload_document"
              id="upload_document"
              accept="application/pdf"
              onChange={handleFileChange}
            />
          </div>
          <div className="d-flex flex-column" style={{ marginLeft: "30px" }}>
            <label className="input-label" htmlFor="customer_name">
              Customer Name
            </label>
            <input
              disabled
              className="input-style"
              type="text"
              name="customer_name"
              id="customer_name"
              value={customerName}
            />
          </div>
        </div>
        <div className="action-div">
          <div className="button-div">
            <button
              className="btn btn-submit"
              onClick={() => {
                handleDocumentSubmit();
              }}
            >
              Submit
            </button>
            <button
              className="btn btn-cancel"
              onClick={handleCancel} // Cancel button now resets the form
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
